import systemConnection from '@/connections/system.service';

function pad2(value) {
  return String(value).padStart(2, '0');
}

function monthLabelFromYearMonth(yearmonth) {
  const monthIndex = Number(String(yearmonth).slice(4, 6)) - 1;
  const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthName[monthIndex] || String(yearmonth);
}

function getYearToDateMonths(year) {
  const today = new Date();
  const endMonth = today.getMonth() + 1;
  const months = [];
  for (let m = 1; m <= endMonth; m++) {
    months.push(`${year}${pad2(m)}`);
  }
  return months;
}

export default {
  namespaced: true,
  state: {
    ytd: {
      year: null,
      email: null,
      months: [],
      rows: [],
      loading: false,
      error: null,
      loadedAt: null,
    },
  },
  mutations: {
    setYtdLoading(state, loading) {
      state.ytd.loading = loading;
    },
    setYtdError(state, error) {
      state.ytd.error = error;
    },
    setYtdData(state, payload) {
      state.ytd.year = payload.year;
      state.ytd.email = payload.email || null;
      state.ytd.months = payload.months;
      state.ytd.rows = payload.rows;
      state.ytd.loadedAt = Date.now();
    },
  },
  actions: {
    async loadYearToDateMonths({ commit }, { year, email } = {}) {
      const targetYear = Number(year) || new Date().getFullYear();
      commit('setYtdLoading', true);
      commit('setYtdError', null);
      try {
        const months = getYearToDateMonths(targetYear).map((ym) => ({
          yearmonth: ym,
          label: monthLabelFromYearMonth(ym),
        }));

        const results = await Promise.all(
          months.map(async (m) => {
            const response = await systemConnection.getDetailsByMonth(m.yearmonth);
            return { yearmonth: m.yearmonth, data: (response && response.data) ? response.data : [] };
          })
        );

        const rows = [];
        results.forEach((r) => {
          (r.data || []).forEach((item) => {
            if (email && item && item.email !== email) return;
            if (!item || !item.platform) return;
            const type = item.type || null;
            const basicCredit = Number(item.basicCredit) || 0;
            const premium = Number(item.premium) || 0;
            const corp = Number(item.corp) || 0;
            const registered = Number(item.registered) || 0;
            const premiumCredit = Number(item.premiumCredit) || 0;
            const corpCredit = Number(item.corpCredit) || 0;
            const premiumCycleAmount = Number(item.premiumCycleAmount) || 0;
            const corpCycleAmount = Number(item.corpCycleAmount) || 0;
            const creditAmount = Number(item.creditAmount) || 0;
            const totalAmount = Number(item.totalAmount) || 0;
            const totalCommission = Number(item.totalCommission) || 0;
            const monthlyTotal = Number(item.monthlyTotal) || 0;
            const basicTotal = Number(item.basicTotal) || 0;
            const premiumTotal = Number(item.premiumTotal) || 0;
            const bulkTotal = Number(item.bulkTotal) || 0;

            rows.push({
              yearmonth: r.yearmonth,
              email: item.email || null,
              platform: item.platform,
              registered,
              basicCredit,
              premium,
              corp,
              premiumCredit,
              corpCredit,
              premiumCycleAmount,
              corpCycleAmount,
              creditAmount,
              totalAmount,
              totalCommission,
              monthlyTotal,
              basicTotal,
              premiumTotal,
              bulkTotal,
              type,
            });
          });
        });

        commit('setYtdData', { year: targetYear, email, months, rows });
      } catch (err) {
        commit('setYtdError', err);
        throw err;
      } finally {
        commit('setYtdLoading', false);
      }
    },
  },
};
